var map = {
	"./Abstract.LogisticsAction.json": 3023,
	"./Abstract.LogisticsActivity.json": 6092,
	"./Abstract.LogisticsAgent.json": 1194,
	"./Abstract.LogisticsObject.json": 5910,
	"./Abstract.LogisticsService.json": 956,
	"./Abstract.PhysicalLogisticsObject.json": 8125,
	"./Action.Check.json": 6590,
	"./Action.Composing.json": 2145,
	"./Action.Loading.json": 618,
	"./Action.Storing.json": 444,
	"./Activity.Storage.json": 9448,
	"./Activity.TransportMovement.json": 177,
	"./Activity.UnitComposition.json": 7025,
	"./Agent.Actor.json": 9320,
	"./Agent.Carrier.json": 7141,
	"./Agent.Company.json": 4182,
	"./Agent.NonHumanActor.json": 1368,
	"./Agent.Organization.json": 804,
	"./Agent.Person.json": 2154,
	"./Agent.PublicAuthority.json": 487,
	"./BillingSettlement.BillingDetails.json": 1559,
	"./Common.Answer.json": 1333,
	"./Common.CheckTemplate.json": 4655,
	"./Common.CheckTotalResult.json": 3256,
	"./Common.ExternalReference.json": 9485,
	"./Common.IotDevice.json": 4599,
	"./Common.LoadingMaterial.json": 9828,
	"./Common.LoadingUnit.json": 7875,
	"./Common.Location.json": 624,
	"./Common.Question.json": 6531,
	"./Common.Sensor.json": 6973,
	"./Core.CO2Emissions.json": 1417,
	"./Core.CustomsInformation.json": 3223,
	"./Core.Insurance.json": 5883,
	"./Core.Item.json": 4558,
	"./Core.PackagingType.json": 5304,
	"./Core.Piece.json": 4301,
	"./Core.Product.json": 9424,
	"./Core.SecurityDeclaration.json": 8341,
	"./Core.Shipment.json": 767,
	"./Core.TransportMeans.json": 4600,
	"./Core.ULD.json": 6396,
	"./Core.Waybill.json": 8817,
	"./DG.DgDeclaration.json": 4714,
	"./DG.DgProductRadioactive.json": 1962,
	"./DG.DgRadioactiveIsotope.json": 634,
	"./DG.ItemDg.json": 8257,
	"./DG.PieceDg.json": 3362,
	"./DG.ProductDg.json": 3359,
	"./Distribution.BookingOption.json": 816,
	"./Distribution.BookingOptionRequest.json": 6682,
	"./Distribution.BookingRequest.json": 2042,
	"./Distribution.BookingShipment.json": 5607,
	"./Distribution.Price.json": 9659,
	"./Distribution.Ratings.json": 8112,
	"./Distribution.TransportLegs.json": 2106,
	"./Embedded.ActivitySequence.json": 722,
	"./Embedded.Address.json": 5326,
	"./Embedded.Adjustments.json": 6954,
	"./Embedded.BookingPreferences.json": 725,
	"./Embedded.BookingTimes.json": 8637,
	"./Embedded.CarrierProduct.json": 5309,
	"./Embedded.Characteristic.json": 3143,
	"./Embedded.CodeListElement.json": 2949,
	"./Embedded.ContactDetail.json": 5075,
	"./Embedded.CurrencyValue.json": 3434,
	"./Embedded.Dimensions.json": 7099,
	"./Embedded.Geolocation.json": 356,
	"./Embedded.LoosePiece.json": 1282,
	"./Embedded.Measurement.json": 1954,
	"./Embedded.MovementTime.json": 4742,
	"./Embedded.OtherCharge.json": 7892,
	"./Embedded.OtherIdentifier.json": 4355,
	"./Embedded.Party.json": 5802,
	"./Embedded.PieceGroup.json": 8687,
	"./Embedded.Ranges.json": 5284,
	"./Embedded.RegulatedEntity.json": 3046,
	"./Embedded.StationRemarks.json": 2999,
	"./Embedded.TemperatureInstructions.json": 4213,
	"./Embedded.ULDBasicPiece.json": 1345,
	"./Embedded.ULDSpecificPiece.json": 2613,
	"./Embedded.UnitsPreference.json": 6244,
	"./Embedded.Value.json": 771,
	"./Embedded.VolumePieceGroup.json": 197,
	"./Embedded.VolumetricWeight.json": 894,
	"./Embedded.WaybillLineItem.json": 1669,
	"./Event.LogisticsEvent.json": 8941,
	"./LiveAnimals.EpermitConsignment.json": 6140,
	"./LiveAnimals.EpermitSignature.json": 1391,
	"./LiveAnimals.LiveAnimalsEpermit.json": 388,
	"./LiveAnimals.PieceLiveAnimals.json": 7216,
	"./Service.Booking.json": 2896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7689;